(function($){
	var vidUrl, shownUrl;
	
	var pauseVideo = function(){
		document.getElementById('video-iframe').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');

		$( '#video-modal' ).off( 'hide.bs.modal', pauseVideo );
	};
	
	var videoPopup = function( e ) {
		e.preventDefault();
		
		vidUrl = $( this ).attr( 'href' );
		
		if  ( typeof vidUrl !== 'undefined' && vidUrl.length ) {
			
			if ( vidUrl !== shownUrl ) {
				shownUrl = vidUrl;
				$( '#video-iframe' ).attr( 'src', vidUrl );
				$( '#video-modal' ).on( 'hide.bs.modal', pauseVideo );
				var videoTitle = $( this ).data( 'video-title' );
	
				if ( ! videoTitle ) {
					videoTitle = 'Watch Video';
				}
				$('#video-modal-title').text( videoTitle );
			}
		
			$( '#video-modal' ).modal();
		}
	};

	$(document).ready(function(){
		$.expr[":"].vid_link = function (a) {
			return a.href.match(/\.youtube\.com\/embed/) || a.href.match(/\.vimeo\.com\/video/);
		};

		$( 'a:vid_link' ).each( function(){
	        if ( ! $( this ).parent().hasClass( 'video-link' ) ) {
		        $( this ).parent().addClass( 'video-link' );
	        }
        });

		$( 'body' ).on( 'click', '.video-link a', videoPopup );
	});
})(jQuery)